//messages.js
export default {
    device_id: "Device",
    public_id: "Public ID",
    device_num: "Device #",
    label: "Label",
    imei: "IMEI",
    sim: "SIM",
    mobile_provider_id: "Mobile Provider",
    hologram_device_id: "Hologram Device ID",
    hologram_link_id: "Hologram Link ID",
    sim_state: "SIM State",
    ip_address: "IP Address",
    record_interval: "Record Interval",
    upload_interval: "Upload Interval",
    power_mode: "Power Mode",
    last_record_date: "Last Record Date",
    version: "Firmware Version",
    change_log: "Change Log",
    battery_full: "Battery Full",
    battery_empty: "Battery Empty",
    device_log_id: "Device Log",
    battery: "Battery",
    signal_quality: "Signal Quality",
    signal: "Signal",
    queued_records: "Queued Records",
    queued: "Queued",
    low: "Low",
    high: "High",
    avg: "Avg",
    elapsed_time: "Elapsed Time",
    device_start: "Device Start",
    device_end: "Device End",
    sensor_data: "Sensor Data",
    device_ports_id: "Device Ports",
    port_number: "Port Number",
    sensor_type_id: "Sensor Type",
    last_measurement: "Last Measurement",
    app_organisation_id: "App Organisation",
    device_type: "Device Type",
    purchase_date: "Purchase Date",
    warranty_period: "Warranty Period",
    interval: "Interval",
    last_read: "Last Read",
    command: "Command",
    surge_protection: "Surge Protection",
    temperature_low_threshold: "Temperature Low Threshold",
    temperature_high_threshold: "Temperature High Threshold",
    notes: "Notes",
    import_id: "Import",
    normal: "Normal",
    year: "Year",
    one_year: "1 Year",
    interval_450: "1 Min (Test Purposes Only)",
    interval_600: "10 Min",
    interval_4500: "10 Min",
    interval_6750: "15 Min",
    interval_9000: "20 Min",
    interval_13500: "30 Min",
    interval_27000: "60 Min",
    initializing: "Initializing...",
    unassigned: "Unassigned",
    pause_caps: "PAUSE",
    live_caps: "LIVE",
    select_tags: "Select Tags",
    reorder_yellow: "Mild Alert (Yellow)",
    reorder_red: "Urgent Alert(Red)",
    size: "Size",
    offset: "Offset",
    add_tank: "Add Tank",
    edit_device_ports: "Edit Device Port",
    product_name: "Product Name",
    port_number: "Port #",
    capacity: "Capacity (g)",
    metric_capacity: "Capacity (l)",
    imperial_capacity: "Capacity (g)",
    select_tank_to_view: "Select Tank to View",
    add_device_port: "Add Device Port",
    modify_device: "Modify Device",
    add_port: "Add Port",
    edit_device: "Edit Device",
    tank_size: "Tank Size",
    sensor_offset: "Sensor Offset",
    remove_tag: "Remove Tag",
    confirm_remove_message: "Are you sure you want to remove this tag?",
    users_last_record_date: "Last Read",
    device_status: "Device Status",
    total_products: "Total Products",
    formatted_version: "Firmware",
    last_network_used: "Last Network",
    radio_tech: "Radio Tech",
    overage_limit: "Overage Limit",
    billing_data_usage: "Data Usage",
    voltage: "Voltage",
    edit_device_port: "Edit Device Port",
    delete_port: "Delete Port",
    surge: "Surge",
    port_history: "Port History",
    device_tags: "Device Tags",
    delete_tag_from_device: "Delete Tag from Device",
    confirm_delete_tag_from_device_message: "Are you sure you want to delete this tag from this device?",
    attach_existing_tags: "Attach Existing Tag(s)",
    modify_device_tags: "Modify Device Tag(s)",
    create_new_tag: "Create New Tag",
    delete_tank: "Delete Tank",
    battery_device: "Battery",
    manage_device_tags: "Manage Device Tag(s)",
    device_monitor: "Device Monitor",
    edit_tank: "Edit Tank",
    no_devices_filter: "No devices found. Please try again with a different filter.",
    metric_height: "Height (mm)",
    metric_diameter: "Diameter (mm)",
    metric_length: "Length (mm)",
    metric_width: "Width (mm)",
    metric_size: "Size (l)",
    metric_sensor_offset: "Sensor Offset (mm)",
    imperial_height: "Height (in)",
    imperial_diameter: "Diameter (in)",
    imperial_length: "Length (in)",
    imperial_width: "Width (in)",
    imperial_size: "Size (g)",
    imperial_sensor_offset: "Sensor Offset (in)",
    last_connected: "Last Connected",
    device_log: "Device Log",
    connection_status: "Connection Status",
    device_alerts: "Device Alerts",
    mild: "Mild",
    urgent: "Urgent",
    clear_search: "Clear Search",
    available_metric_capacity: "Available Capacity (l)",
    available_imperial_capacity: "Available Capacity (g)",
    header_data: "Header Data",
    on_hand: "On Hand",
    available: "Available",
    access: "Access",
    product: "Product",
    quantity: "Quantity",
    add_order: "Add Order",
    submit_order: "Submit Order",
    last_edit: "Last Edit",
    temperature_high_threshold: "High Temperature Threshold (°F)",
    temperature_low_threshold: "Low Temperature Threshold (°F)",
};
